import { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import Row from 'components/Row'
import Spacer from 'components/Spacer'
import NumberSelector from 'components/NumberSelector'
import { maskValue } from 'utils/helpers'
import { setData } from 'store/reducers/info'
import Button from 'components/Button'

export default function HoursDatabases({ values, onBuy, onClose }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const initialValues = useMemo(() => {
    return {
      hours: 4,
      hoursValue: values.hourly.four,
      type: 'hours',
      saving: false,
      plan: '',
      price: '',
    }
  }, [values])

  useEffect(() => {
    dispatch(setData(initialValues))
  }, [dispatch, initialValues])

  const [clicked8, setClicked8] = useState(false)
  const [selection, setSelection] = useState(initialValues)

  function calcDecrement(value) {
    if (value < 8) {
      return (value - 4) * values.hourly.additional + 500
    }
    return selection.hoursValue - values.hourly.additional
  }

  function handleChange(value) {
    let saving = false
    let hoursValue = 0

    if (value === 4) {
      hoursValue = values.hourly.four
    } else {
      if (value >= 8) saving = true

      if (value === 8) {
        hoursValue = values.hourly.eight
      } else {
        if (value < selection.hours) {
          hoursValue = calcDecrement(value)
        } else {
          hoursValue = selection.hoursValue + values.hourly.additional
        }
      }
    }

    setClicked8(saving)

    setSelection({
      ...selection,
      hours: value,
      hoursValue,
      saving,
    })
  }

  function setPackPrice(pack) {
    let saving = false

    if (pack >= 8) saving = true
    setClicked8(saving)

    setSelection({
      ...selection,
      hours: pack,
      hoursValue: pack === 4 ? values.hourly.four : values.hourly.eight,
      saving,
    })
  }

  function handleBuy() {
    const newSelection = {
      ...selection,
      plan: t('home.hourly.modal.purchase_plan', {
        hours: selection.hours,
      }),
      price: t('home.hourly.modal.purchase_plan_price', {
        total: maskValue(selection.hoursValue),
      }),
    }
    onBuy(newSelection)
  }

  return (
    <>
      <Spacer height={50} />
      <Row align="center" justify="center">
        <div className="pack" onClick={() => setPackPrice(4)}>
          <p className="pack-name">{t('home.hourly.table.four_hours')}</p>
          <p className="pack-value">{maskValue(values.hourly.four)}</p>
        </div>
        <Spacer width={30} />
        <div className="pack" onClick={() => setPackPrice(8)}>
          <p className="pack-name">{t('home.hourly.table.eight_hours')}</p>
          <p className="pack-value">{maskValue(values.hourly.eight)}</p>
        </div>
      </Row>
      <Spacer height={30} />

      <Row align="center" justify="center">
        <NumberSelector
          initial={selection.hours}
          min={4}
          onChange={handleChange}
        />
        <Spacer width={10} />
        <p>{t('home.hours')}</p>
        <Spacer width={10} />
        <p className="left price">{maskValue(selection.hoursValue)}</p>
      </Row>
      {clicked8 && <p className="saving">{t('home.hourly.modal.saving')}</p>}
      <Spacer height={40} />
      <p className="footer">
        {t('home.hourly.modal.footer', {
          value: maskValue(values.hourly.additional),
        })}
      </p>
      <Spacer height={30} />
      <p className="purchase_info">
        {t('home.hourly.modal.purchase_info', { hours: selection.hours })}
      </p>

      <Spacer height={30} />
      <Row>
        <Button onClick={onClose} label={t('button.cancel')} />
        <Spacer width={30} />
        <Button
          onClick={handleBuy}
          className="primary"
          label={t('button.buy')}
        />
      </Row>
    </>
  )
}
